import React, { memo } from "react";
import Typography from "@mui/material/Typography";
import ExplorerShadowChipGrid, {
  ExplorerShadowChip,
} from "./ExplorerShadowChipGrid";

type ExplorerFilterSectionsProps = {
  categoryChips: ExplorerShadowChip[];
  sizeChips: ExplorerShadowChip[];
};

const ExplorerFilterSections: React.FC<ExplorerFilterSectionsProps> = ({
  categoryChips,
  sizeChips,
}) => (
  <>
    <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 1.25, color: "#111" }}>
      Categories
    </Typography>
    <ExplorerShadowChipGrid items={categoryChips} sx={{ mb: 2.5 }} />

    <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 1.25, color: "#111" }}>
      Plant Sizes
    </Typography>
    <ExplorerShadowChipGrid items={sizeChips} sx={{ mb: 2.5 }} />
  </>
);

export default memo(ExplorerFilterSections);
